import { render } from "./ShoppingListView.vue?vue&type=template&id=ea594f38"
import script from "./ShoppingListView.vue?vue&type=script&lang=js"
export * from "./ShoppingListView.vue?vue&type=script&lang=js"

import "./ShoppingListView.vue?vue&type=style&index=0&id=ea594f38&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__